<template>
    <div :class="inputClass">
        <p v-html="$t('DELIVERY_ADDRESS_PROPERTY_FIELD_WHAT_KIND_OF_BUILDING')"
            :class="{ 'required-input': mandatory }"/>

        <radio-field
            v-for="(item, index) in options"
            :key="index"
            v-model="val"
            :option="item.option"
            :label="item.label"/>

        <p class="input__message"
           v-if="message"
           v-text="message"/>
    </div>
</template>

<script>
import * as AddressConsts from '@/constants/Address';
import RadioField from '@/components/forms/fields/RadioField';

export default {
    name: 'PropertyTypeField',
    props: {
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
    },
    data: function() {
        return {
            val: null,
            options: [
                {
                    option: AddressConsts.PROPERTY_TYPE_HOUSE,
                    label: this.$t('DELIVERY_ADDRESS_PROPERTY_FIELD_HOUSE'),
                },
                {
                    option: AddressConsts.PROPERTY_TYPE_FLAT,
                    label: this.$t('DELIVERY_ADDRESS_PROPERTY_FIELD_FLAT'),
                },
                {
                    option: AddressConsts.PROPERTY_TYPE_OFFICE,
                    label: this.$t('DELIVERY_ADDRESS_PROPERTY_FIELD_OFFICE'),
                },
            ],
        };
    },
    computed: {
        inputClass() {
            return this.isValid ? 'input input--success' : 'input input--invalid';
        },
    },
    watch: {
        val(value) {
            this.$emit('input', value);
        },
        value: {
            immediate: true,
            handler(value) {
                this.val = value;
            },
        },
    },
    components: {
        RadioField,
    },
};
</script>
